// Form initial values

export const initialValues = {
    selectedProducts: [],
    productCurrency: [],
    productFunds: [
        {
            totalIngresos: 0,
            nombreProducto: '',
            monedaProducto: '',
            categoriaProducto: '',
            idDelProducto: '',
            cantDepositos: '',
            cantRetiros: '',
            montoPromedio: '',
            motivoApertura: '',
            origenFondos: '',
            destinoFondos: '',
            descripcionMontDep: '',
            descripcionMontRet: '',
            paisOrigen: '0',
            paisDestino: '0',
            usaMonedaVirtual: '',
            monedaVirtual: '',
        }
    ],
    movilizacionProductos: {
        totalIngresos: 0,
        entidad: '',
        ciudad: '',
    },
    recaudos: {
        documentoIdentidad: '',
        documentoPasaporte: '',
        hasLevelOneAccount: '',
        constanciaResidenciaRif: '',
        constanciaReferenciaEconomica: '',
        // constanciaEstadoCuentaReferenciaEconomica: '',
        constanciaReferenciaPersonal: '',
        constanciaDocumentoIdentidadReferenciaPersonal: '',
        constanciaDeclaracionJuradaNoCuenta: '',
        constanciaEmpleo: '',
        constanciaIngreso: '',
        constanciaOrdenTribunal: '',
        constanciaPersonaDiscapacitada: '',
        constanciaAutorizacionOperarMercado: '',
        constanciaCarnetLaboral: '',
        constanciaCedulaRepresentanteLegal: '',
        constanciaDesignacionLegalComoRepresentante: '',
        constanciaComplementoFatca: '',
        constanciaDeclaracionJuradaDeIngresos: '',
        // constanciaNegocioPropio: '',
    }
};